import { SubAPI } from "./SubAPI";

export class ApiTokens extends SubAPI {

    list(input: { includeArchived?: boolean }) {
        return this.fetcher.get<ApiToken[]>("/api/api-tokens", input);
    }

    create(input: { name: string; expiresAt: string }) {
        return this.fetcher.post<CreatedApiToken>("/api/api-token", input);
    }

    revoke(input: { id: number; archived: true; archivedReason: string }) {
        return this.fetcher.post<CreatedApiToken>("/api/api-token", input);
    }
}

export type ApiToken = {
    id: number;
    usr: number;
    name: string;
    prefix: string;
    expiresAt: string;
    lastUsedAt: string | null;
    createdAt: string;
    createdBy: number;
    archived: boolean;
    archivedAt: string | null;
    archivedBy: number | null;
    archivedReason: string;
}

export type CreatedApiToken = {
    // token is the raw secret, returned only once at creation.
    token: string;
    record: ApiToken;
}
